export default __webpack_public_path__ + "static/media/10d.ea1e199a.png";